
import type { BlockOptionDefinition } from '../../node_modules/@blokkli/editor/dist/runtime/types/blokkOptions.ts'

export type RuntimeBlockOptionArray = {
  [T in BlockOptionDefinition as T['type']]: [T['type'], T['default']]
}[BlockOptionDefinition['type']]

export type RuntimeBlockOptions = {
  tomas: {},
  from_library: {},
  accordion: {
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  address_list: {
    addressListStyle: 'map'
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  address: {
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  datawrapper: {
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  faq: {},
  dynamics_365: {
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  guidle: {
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  iframe: {
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  image: {
    isHero: boolean
    contextToggleId: string
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  issuu: {
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  link: {
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  logo: {
    bkHiddenGlobally: boolean
  },
  logo_list: {
    bkHiddenGlobally: boolean
  },
  quote: {
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  remote_video: {
    isModal: boolean
    isHero: boolean
    contextToggleId: string
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  slider: {
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  teaser: {
    teaserMedia: 'media' | 'zurichCard'
    showOpeningHours: boolean
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  teaser_list: {
    teaserStyle: 'grid' | 'slider' | 'hero'
    teaserColumns: 'fifth' | 'quarter' | 'third' | 'half' | 'full'
    isDivided: boolean
    isNumbered: boolean
    showMap: boolean
    contextToggleId: string
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  text: {
    isHighlighted: boolean
    twoColumns: boolean
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  text_image_box: {
    isNumbered: boolean
    isFlipped: boolean
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  title: {
    anchorOnly: boolean
    showAnchor: boolean
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  toggle: {
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  toggle_item: {},
  two_columns: {
    grid: 'half' | 'quarter'
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  webcam: {
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  video: {
    isHero: boolean
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  webform: {
    bkHiddenGlobally: boolean
    publicationChannels: Array<'app' | 'web'>
  },
  blokkli_fragment: {}
}

export const BLOCK_OPTIONS: Record<string, Record<string, RuntimeBlockOptionArray>> = {
  "accordion": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ]
  },
  "address_list": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ],
    "addressListStyle": [
      "radios",
      "map"
    ]
  },
  "address": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ]
  },
  "datawrapper": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ]
  },
  "dynamics_365": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ]
  },
  "guidle": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ]
  },
  "iframe": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ]
  },
  "image": {
    "isHero": [
      "checkbox",
      false
    ],
    "contextToggleId": [
      "text",
      ""
    ],
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ]
  },
  "issuu": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ]
  },
  "link": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ]
  },
  "logo": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ]
  },
  "logo_list": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ]
  },
  "quote": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ]
  },
  "remote_video": {
    "isHero": [
      "checkbox",
      false
    ],
    "contextToggleId": [
      "text",
      ""
    ],
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ],
    "isModal": [
      "checkbox",
      false
    ]
  },
  "slider": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ]
  },
  "teaser": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ],
    "teaserMedia": [
      "radios",
      "media"
    ],
    "showOpeningHours": [
      "checkbox",
      true
    ]
  },
  "teaser_list": {
    "contextToggleId": [
      "text",
      ""
    ],
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ],
    "teaserStyle": [
      "radios",
      "grid"
    ],
    "teaserColumns": [
      "radios",
      "fifth"
    ],
    "isDivided": [
      "checkbox",
      false
    ],
    "isNumbered": [
      "checkbox",
      false
    ],
    "showMap": [
      "checkbox",
      false
    ]
  },
  "text": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ],
    "isHighlighted": [
      "checkbox",
      false
    ],
    "twoColumns": [
      "checkbox",
      false
    ]
  },
  "text_image_box": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ],
    "isNumbered": [
      "checkbox",
      false
    ],
    "isFlipped": [
      "checkbox",
      false
    ]
  },
  "title": {
    "showAnchor": [
      "checkbox",
      false
    ],
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ],
    "anchorOnly": [
      "checkbox",
      false
    ]
  },
  "toggle": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ]
  },
  "two_columns": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ],
    "grid": [
      "radios",
      "half"
    ]
  },
  "webcam": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ]
  },
  "video": {
    "isHero": [
      "checkbox",
      false
    ],
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ]
  },
  "webform": {
    "bkHiddenGlobally": [
      "checkbox",
      false
    ],
    "publicationChannels": [
      "checkboxes",
      [
        "app",
        "web"
      ]
    ]
  }
}
